import { render, staticRenderFns } from "./WarrantySidebar.vue?vue&type=template&id=9ef5e808"
import script from "./WarrantySidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarrantySidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WarrantySidebar.vue?vue&type=style&index=0&id=9ef5e808&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports